<template>
  <el-popover
    v-if="buttonListIsNone"
    placement="bottom-start"
    title=""
    trigger="hover"
    popper-class="sy-button-group-popper"
    class="sy-button-group"
    
  >
    <Button
      slot="reference"
      class="sy-button-group-trigger"
      :class="{
        'sy-button-group-trigger-primary': button.type === 'primaryGroup',
        'sy-button-group-trigger-plain': button.type === 'plainGroup'
      }"
      :type="button.type === 'primaryGroup' ? 'primary' : 'plain'"
      :size="button.size"
      :disabled="button.disabled"
    >
      <slot>{{button.name}}</slot><span class="sy-button-group-trigger-icon">|</span><i class="el-icon-arrow-down"></i>
    </Button>
    <div class="sy-button-gallery-more-wrap" v-scrollbarPrettify>
      <template v-for="(item, idx) in button.buttonList">
        <div
          v-if="!item.hidden"
          :key="idx"
          class="sy-button-group-more-item"
          :class="[
            {'sy-button-group-more-item__disabled': item.bind && item.bind.disabled}
          ]"
        >
          <Button
            :key="idx"
            v-bind="{...item, ...item.bind}"
            v-on="item.event"
            type="text"
          >{{item.name}}</Button>
        </div>
      </template>
    </div>
  </el-popover>
</template>

<script>
import Button from '../button/index.vue'
import scrollbarPrettify from '../../../directives/scrollbar-prettify/index'

export default {
  name: 'button-group',
  components: {
    Button
  },
  props: {
    button: {
      type: Object,
      default: () => {
        return {
          // primaryGroup（有色实心按钮组），plainGroup（有色线框按钮组）
          type: 'primaryGroup',
          size: 'default'
        }
      }
    }
  },
  directives: {
    scrollbarPrettify
  },
  computed: {
    // 判断当前按钮组下拉里面的按钮是否都不展示，如果都不展示，走默认逻辑：按钮组整个不展示
    buttonListIsNone () {
      return this.button.buttonList && this.button.buttonList.filter(item => !item.hidden).length
    }
  }
}
</script>

<style scoped lang="scss">
.sy-button-group {
  display: inline-block;
  &+.sy-button-group {
    margin-left: 8px;
  }
}
.sy-button-group-trigger {
  &.sy-button-group-trigger-primary .sy-button-group-trigger-icon {
    color: rgba(255, 255, 255, 0.3);
    margin: 0 10px;
  }
  &.sy-button-group-trigger-plain .sy-button-group-trigger-icon {
    color: rgba(0, 0, 0, 0.2);
    margin: 0 10px;
  }
}
</style>
<style lang="scss">
.sy-button-group-popper {
  padding: 8px 0;
  min-width: 80px;
  max-width: 320px;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  overflow: hidden;
  .sy-button-group-more-item {
    width: 100%;
    line-height: 22px;
    padding: 5px 16px;
    box-sizing: border-box;
    font-size: 14px;
    color: #343434;
    /* hover颜色 */
    &:hover {
      background-color: #F4FAFF;
      // 鼠标滑入按钮组件才变成小手，方便用户确认按钮具体点击范围
      // cursor: pointer;
    }
    .iconfont {
      font-size: 14px;
    }
    // 解决按钮组下 只能点击文本才触发事件的问题
    .sy-button {
      width: 100%;
    }
  }
  .sy-button-group-more-item__disabled {
    color: #A7ACBC;
    &:hover {
      cursor: not-allowed;
    }
  }
  .sy-button-group-more-item--default {
    font-size: 14px;
    .iconfont {
      font-size: 14px;
    }
  }
}
.sy-button-gallery-more-wrap {
  max-height: 380px;
  overflow-y: auto;
}
</style>